import cx from 'classnames'
import { useState } from 'react'

import { capitalize, uid } from '../../igao/utils'
import { PlainButton } from '../../shared/Button'
import { Button } from '../../shared/NarusMaterial'
import indexStyles from '../index.module.scss'

import styles from './tables.module.scss'

const StaticTable = ({ tab, setTab, saveStatic, items, setModal }) => {
  const tabName = `New ${capitalize(tab)}`
  const [ item, setItem ] = useState({
    id: uid(),
    label: ''
  })
  let validator
  if (tab === 'label') {
    validator = item.label.length > 0
  } else {
    validator =
      !items.some(i => i.type === tab && i.label === item.label) &&
      item.label.length > 0
  }

  const handleChange = (key, value) => {
    setItem({
      ...item,
      [key]: value
    })
  }

  const onCancel = () => {
    if (item.label.length === 0) {
      return setTab(null)
    }
    return setModal({
      title:
        'It looks like you have been editing something. If you leave before saving, your changes will be lost.',
      open: true,
      actions: [
        <Button
          key={1}
          label='Cancel'
          onClick={() => setModal(null)}
          grey
        />,
        <Button
          key={2}
          label='Discard'
          onClick={() => {
            setTab(null)
            setModal(null)
          }}
        />
      ]
    })
  }

  return (
    <div className={cx(styles.addQuestionContainer)}>
      <div>
        <div
          style={{
            margin: '0 30px 18px 30px',
            padding: '30px 0px'
          }}
        >
          <label htmlFor='question'>{capitalize(tab)}</label>
          <input
            onChange={e => handleChange('label', e.target.value)}
            value={item.label}
            className={cx(indexStyles.input, indexStyles.action)}
            name='question'
            placeholder={tabName}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            margin: '-10px 30px 30px 30px',
            paddingBottom: '20px'
          }}
        >
          <PlainButton
            label='Cancel'
            onClick={() => onCancel()}
          />
          <PlainButton
            disabled={!validator}
            label='Save'
            style={{ marginLeft: '12px' }}
            btnType='contained'
            color='primary'
            onClick={() => {
              saveStatic(item)
              setTab(null)
              setItem({
                id: uid(),
                label: ''
              })
            }}
          />
        </div>
      </div>
    </div>
  )
}
export default StaticTable
